import React from "react";
import clientSchemaExterne from "../../../doc/schemas/client/client_externe.json";
import clientSchemaInterne from "../../../doc/schemas/client/client_interne.json";
import SchemasInterpretor from "./SchemasInterpretor";

const DocClient = () => {
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <h1 className="mb-4">Documentation Client</h1>
          <SchemasInterpretor
            leftSchema={clientSchemaExterne}
            rightSchema={clientSchemaInterne}
            leftTitle="Schéma Client Externe"
            rightTitle="Schéma Client Interne"
          />
        </div>
      </div>
    </div>
  );
};

export default DocClient;
